module.exports = __webpack_public_path__ + "static/Jason-Muilenburg-3053cc7fc08f516305b81900dec24adb.png";